import type { InitialStateType } from "../../context/EditSessionsContext";
import { compare } from "../compareEdited";

export const hasTraditionalAssignmentChanges = (state: InitialStateType): boolean => {
  const form = state.form;
  if (!form) return false;
  if (
    form.savedSessions?.length ||
    form.sessionsToCreate?.length ||
    Object.keys(form.sessionsToDelete ?? {}).length
  )
    return true;
  const edited = form.editedSessions;
  if (!edited) return false;
  if (form.selectedCreateSession)
    return !!(
      edited.blocks?.selected ||
      edited.blocks?.days?.length ||
      edited.classrooms?.length ||
      edited.instructors?.length ||
      edited.intervals?.some(week => week.checked)
    );
  return (form.selectedSessions ?? []).some(session => !compare(session, state));
};
